/**
 * Die schmale Zeile, zu der VOTE und RATING nach der Abgabe zusammenklappen:
 * „✓ Danke fürs Mitmachen!" — im Editor mit ↺ zum Zurücksetzen.
 */
import type { FunctionComponent } from "react";

interface Props {
    text: string;
    /** Hintergrund des ↺-Knopfs (halbdurchsichtige Textfarbe). */
    knopfGrund: string;
    onZurueck?: () => void;
    /** Schriftstärke der Zeile; Vorgabe SemiBold (s. schrift-staerke.ts). */
    staerke?: number;
}

const DankeZeile: FunctionComponent<Props> = ({ text, knopfGrund, onZurueck, staerke = 600 }) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", fontWeight: staerke }}>
        <span>✓ {text}</span>
        {onZurueck ? (
            <button
                type="button"
                title="Zurücksetzen (nur im Editor)"
                onClick={onZurueck}
                style={{
                    border: "none",
                    background: knopfGrund,
                    color: "inherit",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                    padding: 0,
                }}
            >
                ↺
            </button>
        ) : null}
    </div>
);

export default DankeZeile;
